import React, { useEffect, useState, useMemo, useContext, useCallback } from 'react'
import UserSearchInput from '../../../ProjectsWindow/components/ProjectAuthorization/components/UserSearchInput'
import DatePicker from '../../../../components/DatePicker/DatePicker'
import { VscClearAll } from 'react-icons/vsc'
import { useLanguage } from '../../../../LanguageProvider'
import './SocialHiveGallery.css'
import SHGalleryFolder from './components/SHGalleryFolder/SHGalleryFolder'
import SHGalleryFile from './components/SHGalleryFile/SHGalleryFile'
import ImageCarousel from '../../../../components/ImageCarousel/ImageCarousel'
import SHCommentBox from '../../components/SHCommentBox/SHCommentBox'
import SHGalleryInfo from './components/SHGalleryInfo/SHGalleryInfo'
import AddGalleryFolderModal from '../../components/AddGalleryFolderModal/AddGalleryFolderModal'
import { useToaster } from '../../../../ToasterProvider'
import Services from '../../../../services/Services'
import { FaChevronLeft } from 'react-icons/fa'
import AddGalleryFileModal from '../../components/AddGalleryFileModal/AddGalleryFileModal'
import AlertBox from '../../../../components/AlertBox/AlertBox'
import { MdOutlinePersonPin } from 'react-icons/md'
import GalleryLabelPersonModal from '../../components/GalleryLabelPersonModal/GalleryLabelPersonModal'
import { GeneralContext } from '../../../../GeneralProvider'
import Modal from '../../../../components/Modal/Modal'

export default function SocialHiveGallery({ activeChannel }) {
    const token = localStorage.getItem('token')
    const { toastError } = useToaster()
    const { getTranslation } = useLanguage()
    const { setCreateProjectLoading } = useContext(GeneralContext)

    const [searchQuery, setSearchQuery] = useState('')
    const [startDate, setStartDate] = useState(null)
    const [endDate, setEndDate] = useState(null)
    const [isAddModalOpen, setIsAddModalOpen] = useState(false)
    const [isAddFileModalOpen, setIsAddFileModalOpen] = useState(false)
    const [showCarousel, setShowCarousel] = useState(false)
    const [collections, setCollections] = useState([])
    const [selectedCollection, setSelectedCollection] = useState();
    const [currentSlideIndex, setCurrentSlideIndex] = useState(0);
    const [selectedFile, setSelectedFile] = useState(null);
    const [isDeleteFolderAlertOpen, setIsDeleteFolderAlertOpen] = useState(false);
    const [isDeleteFileAlertOpen, setIsDeleteFileAlertOpen] = useState(false);
    const [selectedCollectionToRemove, setSelectedCollectionToRemove] = useState();
    const [selectedFileToRemove, setSelectedFileToRemove] = useState();
    const [isLabelPersonModalOpen, setIsLabelPersonModalOpen] = useState(false);
    const [fullscreenModalData, setFullscreenModalData] = useState({ isOpen: false, fileUrl: '', fileName: '', gallery: null, initialIndex: 0 });

    // Fetch folder collections
    const getCollections = useCallback(() => {
        Services.SocialHiveGalleryGetCollections(token, activeChannel.channelID)
            .then((res) => {
                if (res.data.status) {
                    setCollections(res.data.result)
                }
            })
            .catch((err) => {
                console.error(err)
                toastError(getTranslation('somethingWentWrong'))
            })
    }, [token, activeChannel.channelID, toastError, getTranslation])



    const getCollectionDetail = (collectionID) => {
        Services.SocialHiveGalleryGetCollectionDetail(token, activeChannel.channelID, collectionID)
            .then((res) => {
                if (res.data.status) {
                    setSelectedCollection(res.data.result)
                } else {
                    toastError(getTranslation('somethingWentWrong'))
                }
            })
            .catch((err) => {
                console.error(err)
                toastError(getTranslation('somethingWentWrong'))
            })
    }

    useEffect(() => {
        getCollections()
    }, [activeChannel, getCollections])

    const slides = useMemo(() => {
        const files = selectedCollection?.files;
        if (Array.isArray(files) && files.length > 0) {
            return files
                .filter(file => file.fileURL)    // isteğe bağlı: sadece fileURL içerenleri al
                .map(file => file.fileURL);
        }
        return [];
    }, [selectedCollection]);

    const slidesWithFiles = useMemo(() => {
        const files = selectedCollection?.files;
        if (Array.isArray(files) && files.length > 0) {
            return files.filter(file => file.fileURL);
        }
        return [];
    }, [selectedCollection]);

    const handleConfirmDeleteFolder = () => {
        setCreateProjectLoading(true);
        Services.SocialHiveRemoveGalleryFolder(token, selectedCollectionToRemove.channelID, selectedCollectionToRemove.collectionID)
            .then((res) => {
                setCreateProjectLoading(false);
                if (res.data.status) {
                    // Clear selected collection to redirect to main gallery
                    setSelectedCollection(null);
                    // Remove the deleted collection from the current collections array
                    setCollections(prevCollections => 
                        prevCollections.filter(collection => 
                            collection.collectionID !== selectedCollectionToRemove.collectionID
                        )
                    );
                } else {
                    toastError(getTranslation('somethingWentWrong'))
                }
                setIsDeleteFolderAlertOpen(false)
            })
            .catch((err) => {
                setCreateProjectLoading(false);
                console.error(err)
                toastError(getTranslation('somethingWentWrong'))
                setIsDeleteFolderAlertOpen(false)
            })
    }

    const handleCancelDeleteFolder = () => {
        setIsDeleteFolderAlertOpen(false)
    }

    const handleConfirmDeleteFile = () => {
        Services.SocialHiveRemoveGalleryFile(token, selectedFileToRemove.channelID, selectedFileToRemove.collectionID, selectedFileToRemove.fileID)
            .then((res) => {
                if (res.data.status) {
                    getCollectionDetail(selectedFileToRemove.collectionID)
                    // Close the carousel after successful deletion
                    setShowCarousel(false)
                    setSelectedFile(null)
                } else {
                    toastError(getTranslation('somethingWentWrong'))
                }
                setIsDeleteFileAlertOpen(false)
            })
            .catch((err) => {
                console.error(err)
                toastError(getTranslation('somethingWentWrong'))
            })
    }

    const handleCancelDeleteFile = () => {
        setIsDeleteFileAlertOpen(false)
    }

    function getFirstAndLastInitials(sentence) {
        const words = sentence
            .trim()
            .split(/\s+/)
            .filter(w => w.length > 0);
        if (words.length === 0) return '';
        const firstInitial = words[0][0];
        const lastInitial = words[words.length - 1][0];
        return (firstInitial + lastInitial).toUpperCase();
    }

    function getAvatarColor(userName) {
        if (!userName) return 'var(--avatar-color-1)';
        const initials = getFirstAndLastInitials(userName);
        if (!initials) return 'var(--avatar-color-1)';
        // Use a simple hash to consistently map to one of 4 colors
        const hash = initials.charCodeAt(0) + (initials.length > 1 ? initials.charCodeAt(1) : 0);
        const colorIndex = (hash % 4) + 1;
        return `var(--avatar-color-${colorIndex})`;
    }

    const handleFullscreen = (imageUrl, currentIndex) => {
        if (!selectedCollection || !Array.isArray(filteredItems)) return;

        setFullscreenModalData({
            isOpen: true,
            fileUrl: imageUrl,
            fileName: filteredItems[currentIndex]?.title || filteredItems[currentIndex]?.name || 'Image',
            gallery: null, // Disable gallery navigation
            initialIndex: 0
        });
    }

    const filteredItems = useMemo(() => {
        const items = selectedCollection
            ? selectedCollection.files
            : collections;

        if (items.length > 0) {
            return items?.filter(item => {
                const query = searchQuery.trim().toLowerCase();
                const text = (item.title || item.name).toLowerCase();
                const desc = (item.description || '').toLowerCase();

                const matchesSearch = !query || text.includes(query) || desc.includes(query);
                const createdAt = new Date(Number(item.createdDateTime ?? item.createdDateTime) * 1000);
                const afterStart = !startDate || createdAt >= startDate;
                const beforeEnd = !endDate || createdAt <= endDate;

                return matchesSearch && afterStart && beforeEnd;
            });
        }
        else return [];
    }, [collections, selectedCollection, searchQuery, startDate, endDate]);

    const handleSearch = value => setSearchQuery(value)
    const handleStartDateChange = value => setStartDate(value)
    const handleEndDateChange = value => setEndDate(value)
    const handleClear = () => {
        setSearchQuery('')
        setStartDate(null)
        setEndDate(null)
    }

    // Function to determine bento size for items
    const getBentoSize = (index) => {
        const patterns = [
            'medium', 'small', 'small', 'wide', 'small', 'small', 'large', 'small',
            'small', 'medium', 'small', 'small', 'tall', 'small', 'small', 'wide',
            'small', 'small', 'medium', 'small', 'small', 'large', 'small', 'small',
            'wide', 'small', 'small', 'medium', 'small', 'small', 'tall', 'small'
        ]
        
        // Use pattern optimized for dense packing with better space utilization
        return patterns[index % patterns.length]
    }

    return (
        <div className="social-hive-pages-main" style={{ paddingTop: 0 }}>
            {!showCarousel &&

                <div
                    style={{
                        flexDirection: 'row',
                        display: 'flex',
                        position: 'sticky',
                        top: 0,
                        backgroundColor: 'inherit',
                        zIndex: 99,
                        marginLeft: '-2px',
                        marginBottom: '2px',
                        alignItems: 'center',
                        gap: '15px',
                    }}
                >
                    {selectedCollection && (
                        <button
                            onClick={() => setSelectedCollection(null)}
                            className="kronos-add-manual-button"
                            style={{ width: "34px", height: "34px", padding: 0 }}
                        >
                            <FaChevronLeft />
                        </button>
                    )}
                    <UserSearchInput
                        style={{ marginBottom: '21px', height: '15px' }}
                        placeholder={getTranslation('search')}
                        onSearch={handleSearch}
                        value={searchQuery}
                    />
                    <DatePicker
                        key={`startDate-${startDate?.toISOString() || 'none'}`}
                        buttonStyle={{ width: '132px', height: '38px' }}
                        initialDate={startDate}
                        onDateSelect={handleStartDateChange}
                        toggleLabel={getTranslation('startDate')}
                    />
                    <DatePicker
                        key={`endDate-${endDate?.toISOString() || 'none'}`}
                        buttonStyle={{ width: '132px', height: '38px' }}
                        initialDate={endDate}
                        onDateSelect={handleEndDateChange}
                        toggleLabel={getTranslation('endDate')}
                    />

                    <span
                        style={{
                            color: 'var(--sh-chat-message-font-color)',
                            cursor: 'var(--pointer)',
                        }}
                        onClick={handleClear}
                    >
                        <VscClearAll size={23} />
                    </span>


                    {activeChannel.isAdmin === "1" &&
                        <>
                            {!selectedCollection ?
                                <button
                                    onClick={() => setIsAddModalOpen(true)}
                                    className="sh-settings-action-button"
                                    style={{ marginTop: 0, alignSelf: 'auto', height: '38px', maxHeight: '38px', alignItems: 'center', justifyContent: 'center', paddingInline: '5px', fontSize: '11px' }}
                                >
                                    {getTranslation('addNewFolder')}
                                </button>
                                :
                                <div style={{ display: 'flex', gap: '8px' }}>
                                    <button
                                        onClick={() => setIsAddFileModalOpen(true)}
                                        className="sh-settings-action-button"
                                        style={{ marginTop: 0, alignSelf: 'auto', height: '38px', maxHeight: '38px', alignItems: 'center', justifyContent: 'center', paddingInline: '5px', fontSize: '11px' }}
                                    >
                                        {getTranslation('uploadFile')}
                                    </button>
                                    <button
                                        onClick={() => { setIsDeleteFolderAlertOpen(true); setSelectedCollectionToRemove(selectedCollection); }}
                                        className="sh-action-button danger-button"
                                        style={{ marginTop: 0, height: '38px', maxHeight: '38px', paddingInline: '8px', fontSize: '11px' }}
                                    >
                                        {getTranslation('deleteGallery')}
                                    </button>
                                </div>
                            }
                        </>
                    }


                </div>
            }

            {!selectedCollection ?

                <>
                    <div className="sh-gallery-folder-grid">
                        {filteredItems.map(col => (
                            <SHGalleryFolder
                                key={col.id}
                                folderName={col.title}
                                description={col.description}
                                coverImageURL={col.coverImageURL}
                                onClick={() => getCollectionDetail(col.collectionID)}
                                onDelete={() => { setIsDeleteFolderAlertOpen(true); setSelectedCollectionToRemove(col); }}
                                isAdmin={activeChannel.isAdmin}
                            />
                        ))}
                    </div>
                </>
                :
                <>

                    {showCarousel ? (
                        <>
                            <div className="sh-info-container">
                                <div className="sh-info-main" style={{ maxHeight: '480px' }}>
                                    <ImageCarousel
                                        slides={slides}
                                        startIndex={currentSlideIndex}
                                        onSlideChange={newIdx => {
                                            setCurrentSlideIndex(newIdx);
                                            setSelectedFile(slidesWithFiles[newIdx]);
                                        }}
                                        onClose={() => setShowCarousel(false)}
                                        onFullscreen={handleFullscreen}
                                    />
                                    <div className="sh-gallery-tag-section">
                                        {activeChannel.isAdmin === "1" &&
                                            <button onClick={() => setIsLabelPersonModalOpen(true)} type="button" className="sh-action-button download-button sh-gallery-tag-button">
                                                <MdOutlinePersonPin className="action-icon" />
                                                <span>{getTranslation("tag")}</span>
                                            </button>
                                        }
                                        {Array.isArray(selectedFile?.labelledUsers) && selectedFile.labelledUsers.length > 0 && (
                                            <div className="sh-gallery-tagged-people-display">
                                                <div className="sh-gallery-tagged-avatars">
                                                    {selectedFile.labelledUsers.slice(0, 4).map((label, index) => {
                                                        const avatarUrl = label.userInfos.userAvatar;
                                                        return avatarUrl ? (
                                                            <img
                                                                key={label.id}
                                                                src={avatarUrl}
                                                                alt={`${label.userInfos.name} ${label.userInfos.lastname}`}
                                                                className="sh-gallery-tagged-avatar"
                                                                style={{ zIndex: 4 - index }}
                                                            />
                                                        ) : (
                                                            <div 
                                                                key={label.id}
                                                                className="sh-gallery-tagged-avatar sh-gallery-tagged-avatar-initials"
                                                                style={{ 
                                                                    zIndex: 4 - index,
                                                                    backgroundColor: getAvatarColor(`${label.userInfos.name} ${label.userInfos.lastname}`)
                                                                }}
                                                            >
                                                                {getFirstAndLastInitials(`${label.userInfos.name} ${label.userInfos.lastname}`)}
                                                            </div>
                                                        );
                                                    })}
                                                </div>
                                            </div>
                                        )}
                                    </div>
                                </div>
                            </div>
                            <div className="sh-gallery-bottom-layout">
                                <div className="sh-gallery-info-area">
                                    <SHGalleryInfo onClose={() => setShowCarousel(false)} file={selectedFile} getCollectionDetail={(id) => getCollectionDetail(id)} onDeleteFile={() => { setIsDeleteFileAlertOpen(true); setSelectedFileToRemove(selectedFile); }} />
                                </div>
                                <div className="sh-gallery-comments-area">
                                    <SHCommentBox
                                        comments={
                                            Array.isArray(selectedFile?.comments)
                                                ? selectedFile.comments
                                                : []
                                        }
                                        file={selectedFile}
                                        getCollectionDetail={(id) => getCollectionDetail(id)}
                                    />
                                </div>
                            </div>
                        </>
                    ) :
                        <>

                            {Array.isArray(filteredItems) && filteredItems.length > 0 && (
                                <div className='sh-gallery-file-grid'>
                                    {filteredItems.map((file, idx) => (
                                        <SHGalleryFile
                                            key={file.id}
                                            fileName={file.title || file.name}
                                            img={file.previewImageURL || file.fileURL || file.coverImageURL}
                                            onClick={() => {
                                                setSelectedFile(file);
                                                setCurrentSlideIndex(idx);
                                                setShowCarousel(true);
                                            }}
                                            bentoSize={getBentoSize(idx)}
                                        />
                                    ))}
                                </div>
                            )}
                        </>
                    }
                </>
            }

            <AlertBox
                isOpen={isDeleteFolderAlertOpen}
                title={getTranslation("areYouSure")}
                message={getTranslation("deleteFolderWarning")}
                onConfirm={handleConfirmDeleteFolder}
                onCancel={handleCancelDeleteFolder}
                confirmText={getTranslation("yes")}
                cancelText={getTranslation("no")}
                type={"warning"}
            />

            <AlertBox
                isOpen={isDeleteFileAlertOpen}
                title={getTranslation("areYouSure")}
                message={getTranslation("deleteFileWarning")}
                onConfirm={handleConfirmDeleteFile}
                onCancel={handleCancelDeleteFile}
                confirmText={getTranslation("yes")}
                cancelText={getTranslation("no")}
                type={"warning"}
            />

            <AddGalleryFolderModal
                getCollections={getCollections}
                selectedChannel={activeChannel}
                isOpen={isAddModalOpen}
                onClose={() => setIsAddModalOpen(false)}
            />

            <AddGalleryFileModal
                getCollectionDetail={() => getCollectionDetail(selectedCollection.collectionID)}
                collectionID={selectedCollection?.collectionID}
                selectedChannel={activeChannel}
                isOpen={isAddFileModalOpen}
                onClose={() => setIsAddFileModalOpen(false)}
            />

            <GalleryLabelPersonModal
                isOpen={isLabelPersonModalOpen}
                onClose={() => setIsLabelPersonModalOpen(false)}
                activeChannel={activeChannel}
                getCollectionDetail={() => getCollectionDetail(selectedCollection.collectionID)}
                selectedFile={selectedFile}
            />

            {fullscreenModalData.isOpen && (
                <Modal
                    fileUrl={fullscreenModalData.fileUrl}
                    fileName={fullscreenModalData.fileName}
                    mimeType="image/"
                    simple={true}
                    onClose={() => setFullscreenModalData({ isOpen: false, fileUrl: '', fileName: '', gallery: null, initialIndex: 0 })}
                />
            )}
        </div>
    )
}
